"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaintNode = void 0;
const react_1 = __importStar(require("react"));
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../Colors");
const theme_1 = require("../../editor/theme");
const SharedNode_1 = require("./SharedNode");
const trees_1 = require("../../state/containers/trees");
const index_1 = require("../DOM/index");
const MainNodeArea = {
    position: 'relative',
    borderColor: 'transparent',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 4,
    cursor: 'pointer',
    transition: `border-color 0.25s ease-in-out`,
    $nest: {
        '.NodeTitle': Object.assign(Object.assign({}, SharedNode_1.NodeTitle), { borderBottomLeftRadius: 4, borderBottomRightRadius: 4, background: 'transparent' }),
        '&:hover': {
            borderColor: Colors_1.Colors.green[0],
        },
    },
};
const LibraryNodeContainer = typestyle_1.style({
    $nest: Object.assign({ '.MainNodeArea': MainNodeArea }, Object.keys(theme_1.GraphQLBackgrounds).reduce((a, b) => {
        a[`.NodeType-${b}`] = {
            borderColor: `${theme_1.GraphQLBackgrounds[b]}`,
            borderStyle: 'dashed',
        };
        return a;
    }, {})),
});
const MainNodeContainer = typestyle_1.style({
    $nest: Object.assign({ '.MainNodeArea': MainNodeArea }, Object.keys(theme_1.GraphQLBackgrounds).reduce((a, b) => {
        a[`.NodeType-${b}`] = {
            background: `${theme_1.GraphQLBackgrounds[b]}`,
        };
        return a;
    }, {})),
});
const NodeContainer = typestyle_1.style({
    margin: 15,
});
const MatchedSearchContainer = typestyle_1.style({
    opacity: 1,
});
const NoMatchedSearchContainer = typestyle_1.style({
    opacity: 0.2,
});
const UnRelatedNode = typestyle_1.style({
    opacity: 0.2,
});
const RelatedNode = typestyle_1.style({
    opacity: 1.0,
});
exports.PaintNode = ({ node, isLibrary, isMatchedToSearch }) => {
    const thisNode = react_1.useRef(null);
    const { setSelectedNode, setPosition, relatedToSelected } = trees_1.useTreesState();
    const relatedNodes = relatedToSelected();
    let relationClass = '';
    if (relatedNodes) {
        if (relatedNodes.includes(node.name)) {
            relationClass = RelatedNode;
        }
        else {
            relationClass = UnRelatedNode;
        }
    }
    return (react_1.default.createElement("div", { className: `${NodeContainer} ${relationClass} ${isLibrary ? LibraryNodeContainer : MainNodeContainer} ${isMatchedToSearch ? MatchedSearchContainer : NoMatchedSearchContainer}`, ref: thisNode, style: {} },
        react_1.default.createElement("div", { className: `MainNodeArea NodeType-${node.type.name}`, onClick: (e) => {
                e.stopPropagation();
                if (index_1.DOM.panLock)
                    return;
                setSelectedNode(undefined);
                setTimeout(() => {
                    setSelectedNode({
                        data: node.data,
                        name: node.name,
                        type: node.type,
                    });
                    const rect = thisNode.current;
                    if (rect) {
                        setPosition({
                            offsetLeft: rect.offsetLeft,
                            offsetTop: rect.offsetTop,
                            width: rect.offsetWidth,
                        });
                    }
                }, 1);
            } },
            react_1.default.createElement("div", { className: `NodeTitle` },
                react_1.default.createElement("div", { className: `NodeName` }, node.name)))));
};
